import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { AiFlowService } from '../../../../../../../core/services/core.ai-flow.service';

@Component({
  selector: 'tracker-admin-workflow-transition-tab-ai',
  template: require('./tracker.workflow.transition.tab.ai.component.html'),
})
export class TrackerAdminWorkflowTransitionTabAiComponent implements OnInit {
  @Input() toFieldElement: any;
  @Input() projectId: number;

  aiConfigured = false;
  postSuccessFollowupChoices = { 'No': false, 'Yes': true };

  promptTokens = [
    { token: '{{data.tracker_item_id}}' },
    { token: '{{data.field_name}}' },
    { token: '{{data.from_element}}' },
    { token: '{{data.to_element}}' },
    { token: '{{project.name}}' },
  ];

  constructor(private aiFlowService: AiFlowService) {}

  ngOnInit() {
    if (_.isEmpty(this.toFieldElement.llmOptions)) {
      this.toFieldElement.llmOptions = { postSuccessFollowup: false };
    }

    this.aiFlowService.getAiConfig(this.projectId)
      .then(settings => {
        this.aiConfigured = !!(settings && settings.ai_enabled && settings.ai_enabled.value === true);
      })
      .catch(() => {
        this.aiConfigured = false;
      });
  }

  insertToken(token: string, textarea: HTMLTextAreaElement) {
    const current = this.toFieldElement.llmPrompt || '';
    const start = textarea.selectionStart ?? current.length;
    const end = textarea.selectionEnd ?? current.length;

    this.toFieldElement.llmPrompt = current.slice(0, start) + token + current.slice(end);

    const cursorPos = start + token.length;
    setTimeout(() => {
      textarea.focus();
      textarea.setSelectionRange(cursorPos, cursorPos);
    });
  }
}
